import React, { useEffect, useState } from "react";

const API_URL = "https://rbuymart.rbhardwaj.com/server/api/admin/flipkart_auth.php";

export default function FlipkartAdmin() {
  const [appId, setAppId] = useState("");
  const [appSecret, setAppSecret] = useState("");
  const [statusData, setStatusData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const getAuthToken = () => {
    return (
      localStorage.getItem("token") ||
      localStorage.getItem("admin_token") ||
      localStorage.getItem("access_token") ||
      ""
    );
  };

  const safeFetch = async (url, options = {}) => {
    const res = await fetch(url, options);
    const text = await res.text();
    let data = {};
    if (text) {
      try { data = JSON.parse(text); } 
      catch (e) { throw new Error("Server returned non-JSON response."); }
    }
    if (!res.ok) throw new Error(data.message || `HTTP Error ${res.status}`);
    return data;
  };

  const fetchCredentials = async () => {
    try {
      const res = await safeFetch(API_URL, {
        headers: { Authorization: `Bearer ${getAuthToken()}` },
      });
      if (res.configured && res.data) {
        setStatusData(res.data);
        setAppId(res.data.app_id || "");
      }
    } catch (err) {
      setMessage({ type: "error", text: err.message });
    }
  };

  useEffect(() => {
    fetchCredentials();
  }, []);

  const handleSaveCredentials = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });

    try {
      const res = await safeFetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAuthToken()}`,
        },
        body: JSON.stringify({
          action: "save_credentials",
          app_id: appId,
          app_secret: appSecret,
        }),
      });

      setMessage({ type: "success", text: res.message });
      setAppSecret("");
      fetchCredentials();
    } catch (err) {
      setMessage({ type: "error", text: err.message });
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateToken = async () => {
    setLoading(true);
    setMessage({ type: "", text: "" });

    try {
      const res = await safeFetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAuthToken()}`,
        },
        body: JSON.stringify({ action: "generate_token" }),
      });

      setMessage({ type: "success", text: res.message });
      fetchCredentials();
    } catch (err) {
      setMessage({ type: "error", text: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Flipkart Developer API Integration</h2>

      {message.text && (
        <div style={{ ...styles.alert, backgroundColor: message.type === "error" ? "#ff4d4f" : "#52c41a" }}>
          {message.text}
        </div>
      )}

      {/* CREDENTIALS FORM */}
      <div style={styles.card}>
        <h3>1. API Credentials</h3>
        <form onSubmit={handleSaveCredentials}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Application ID (App ID):</label>
            <input
              type="text"
              style={styles.input}
              value={appId}
              onChange={(e) => setAppId(e.target.value)}
              placeholder="Enter Flipkart App ID"
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Application Secret Key:</label>
            <input
              type="password"
              style={styles.input}
              value={appSecret}
              onChange={(e) => setAppSecret(e.target.value)}
              placeholder={statusData?.app_secret ? "Leave blank to keep existing secret" : "Enter Secret Key"}
            />
          </div>

          <button type="submit" disabled={loading} style={styles.buttonPrimary}>
            {loading ? "Saving..." : "Save Credentials"}
          </button>
        </form>
      </div>

      {/* TOKEN STATUS CARD */}
      <div style={styles.card}>
        <h3>2. OAuth 2.0 Access Token Status</h3>
        {statusData?.access_token ? (
          <div>
            <p><b>Token Status:</b> {statusData.is_expired ? <span style={{ color: "red" }}>Expired</span> : <span style={{ color: "green" }}>Active</span>}</p>
            <p><b>Expires At:</b> {statusData.expires_at}</p>
            <p><b>Access Token:</b> <code style={styles.code}>{statusData.access_token.substring(0, 30)}...</code></p>
          </div>
        ) : (
          <p style={{ color: "#666" }}>No active token generated yet.</p>
        )}

        <button
          onClick={handleGenerateToken}
          disabled={loading}
          style={{ ...styles.buttonSuccess, marginTop: "15px" }}
        >
          {loading ? "Connecting to Flipkart..." : "Generate New Access Token"}
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "900px",
    margin: "30px auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },
  heading: {
    textAlign: "center",
    marginBottom: "30px",
    color: "#1890ff",
  },
  card: {
    background: "#fff",
    padding: "25px",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    marginBottom: "25px",
  },
  formGroup: {
    marginBottom: "15px",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  buttonPrimary: {
    background: "#1890ff",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  buttonSuccess: {
    background: "#52c41a",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  alert: {
    padding: "12px 20px",
    color: "#fff",
    borderRadius: "5px",
    marginBottom: "20px",
    fontWeight: "bold",
  },
  code: {
    background: "#f5f5f5",
    padding: "4px 8px",
    borderRadius: "4px",
    wordBreak: "break-all",
  },
};